import React, { Component } from "react";
import { Row, Col, Button, Form, Select, message } from "antd";
import "./EvaluationMember.css";
import { withRouter } from "react-router-dom";
import { API } from "../../../API/API";
import UserContext from "../../UserContext/UserContext";
import { baseConfig } from "../../../Config/Config";
class EvaluationMemberAdd extends Component {
  static contextType = UserContext;
  formRef = React.createRef();
  state = {
    invitationid: this.props.invitationid,
    evaluationid: this.props.evaluationid,
    tendername: this.props.tendername,
    emplist: [],
    membertypelist: [],
    membertypeid: this.props.membertypeid,
    empid: this.props.empid,
    empname: null,
    membertypename: null,
    email: null,
    dkey: 1,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    API.get("/getMemberTypeList").then((response) => {
      if (response.status === 200) {
        this.setState((prevState) => ({
          membertypelist: response.data.retData,
          dkey: prevState.dkey + 1,
        }));
      }
    });
    API.get("/getEmployees").then((response) => {
      if (response.status === 200) {
        this.setState((prevState) => ({
          emplist: response.data.retData,
          dkey: prevState.dkey + 1,
        }));
      }
    });
    API.get("/getMemberById?id=" + this.state.evaluationid).then((response) => {
      if (response.status === 200) {
        if (response.data.retData.length > 0) {
          this.setState((prevState) => ({
            membertypeid: response.data.retData[0].membertypeid,
            empid: response.data.retData[0].empid,
            dkey: prevState.dkey + 1,
          }));
        }
      }
    });
  };
  onChangeEmp = (value) => {
    this.setState({ empid: value });
    let employee = this.state.emplist.filter(emp => emp.empid == value);
    if (employee.length > 0){
      this.setState({ email: employee[0]["email"] });
      this.setState({ empname: employee[0]["empname"] });
    }
  };
  onChangeType = (value) => {
    this.setState({ membertypeid: value });
    let membertype = this.state.membertypelist.filter(list => list.membertypeid == value);
    if (membertype.length > 0){
      this.setState({ membertypename: membertype[0]["membertypename"] });
    }
  };
  onSave = () => {
    if (this.state.empid && this.state.membertypeid) {
      let param = [
        {
          invitationid: this.state.invitationid,
          empid: this.state.empid,
          email: this.state.email,
          membertypeid: this.state.membertypeid,
          createdby: this.context.username,
          evaluationid: this.state.evaluationid,
          url: baseConfig.makurl,
          session_id: localStorage.getItem("access_token"),
          tendername: this.state.tendername,
          empname: this.state.empname,
          membertypename: this.state.membertypename
        },
      ];
      API.post("/saveMembers", param).then((response) => {
        if (response.status === 200 && response.data.retType === 0) {
          this.props.showForm(false, 0);
          message.success("Амжилттай хадгаллаа.");
        }
      });
    }
  };
  render() {
    return (
      <div id="member-add" key={this.state.dkey}>
        <Form
          className="formDrawer"
          ref={this.formRef}
          onFinish={this.onSubmit}
          layout="vertical"
          initialValues={{}}
        >
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Ажилтан сонгох"
                name="empid"
                rules={[
                  {
                    required: true,
                    message: "Ажилтан сонгоно уу.",
                  },
                ]}
                initialValue={this.state.empid}
              >
                <Select
                  style={{ width: "100%", height: 30 }}
                  showSearch
                  allowClear
                  optionFilterProp="name"
                  onChange={this.onChangeEmp}
                  defaultValue={this.state.empid}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {this.state.emplist &&
                    this.state.emplist?.map((t, i) => (
                      <Select.Option key={i} value={t.empid}>
                        {t.empname}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Form.Item
                style={{ fontWeight: 700 }}
                label="Чиг үүрэг"
                name="membertypeid"
                rules={[
                  {
                    required: true,
                    message: "Чиг үүрэг сонгоно уу.",
                  },
                ]}
                initialValue={this.state.membertypeid}
              >
                <Select
                  style={{ width: "100%", height: 30 }}
                  showSearch
                  allowClear
                  optionFilterProp="name"
                  onChange={this.onChangeType}
                  defaultValue={this.state.membertypeid}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {this.state.membertypelist &&
                    this.state.membertypelist?.map((t, i) => (
                      <Select.Option key={i} value={t.membertypeid}>
                        {t.membertypename}
                      </Select.Option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Form.Item className="buttonForm" label=" ">
            <Button
              type="primary"
              className="btnPrimary"
              htmlType="submit"
              onClick={this.onSave}
            >
              Гишүүн үүсгэх
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

export default withRouter(EvaluationMemberAdd);
